import React, { useState, useEffect, useCallback } from 'react'
import Section from "Layout/Section";
import Layout from "Layout";
import CartBundleForm from 'components/BundlePromotion/CartBundleForm';
import { useSelector, useDispatch } from "react-redux";
import { IState } from "store/store.interface";
import { TBundleFieldType } from "store/reducers/bundlePromotion.reducers";
import { fetchBundleFieldsDetails } from "store/actions/bundlePromotion.actions";
import { setLocation } from "store/actions/auth.actions";
import { IBundlePromotionForm } from "../../store/reducers/bundlePromotion.reducers"


const CartBundleCreate: React.FC = () => {
  const {
    creationBundleForm,
  } = useSelector((state: IState) => ({
    ...state.bundlePromotion,
    ...state.config,
  }));

  const dispatch = useDispatch();
  const [registeredFields, setRegisteredFields] = useState([] as TBundleFieldType[]);

  const [formErrors, setFormErrors] = useState<{
    [key: string]: { isError: boolean; message?: string };
  }>({});

  const onUnRegisterField = (id: string) => {
    setRegisteredFields((oldState: TBundleFieldType[]) => {
      return oldState.filter((field) => field.id !== id);
    });
  };

  const getValue: any = useCallback(
    (fieldName: keyof IBundlePromotionForm) => {
      return creationBundleForm[fieldName] ?? "";
    },
    [creationBundleForm]
  );

  const onValidateInputs = (
    errorObj: { [key: string]: { isError: boolean; message?: string } } = {}
  ) => {
    setFormErrors((oldState) => ({ ...oldState, ...errorObj }));
  };

  const onRegisterField = (field: TBundleFieldType) => {
    if (registeredFields.filter(({ id }) => id === field.id).length === 0) {
      setRegisteredFields((oldState: TBundleFieldType[]) => [...oldState, field]);
    }
  };

  // /**
  //  * function to check if the registered values is required and has value
  //  */

  const validateFields = useCallback(
    (shouldRegisterErrors: boolean) => {
      let updatedErrors: {
        [key: string]: { isError: boolean; message?: string };
      } = { ...formErrors };
      registeredFields.forEach((field) => {
        const { isRequired, startDateKeys, endDateKeys, name } = field;
        let isError = false;
        if (isRequired) {
          const value = getValue(name);
          const startDateValue = getValue(startDateKeys);
          const endDateValue = getValue(endDateKeys);
          if (name === "dateRange") {
            if (
              !startDateValue ||
              !endDateValue ||
              startDateValue < new Date()
            ) {
              isError = true;
            }
          } else if (!value) {
            isError = true;
          }
        }
        if (
          ["includedPosId", "excludedPosId"].includes(name) &&
          !getValue("includedPosId") &&
          !getValue("excludedPosId")
        ) {
          isError = true;
        }
        if (
          (formErrors?.[name] &&
            !formErrors[name].isError &&
            !isError) ||
          isError
        ) {
          updatedErrors = { ...updatedErrors, ...{ [name]: { isError } } };
        }
      });
      if (shouldRegisterErrors) {
        setFormErrors((oldErrors) => ({
          ...oldErrors,
          ...updatedErrors,
        }));
      }
      return (
        Object.keys(updatedErrors).filter(
          (key) => updatedErrors[key].isError
        ).length === 0
      );
    },
    [getValue, registeredFields, formErrors]
  );

  const FormValidationHandler = useCallback(() => {
  const validationValue = validateFields(false);
  return !!validationValue;
}, [validateFields]);


  useEffect(() => {
    const { type } = creationBundleForm || {};
    if (!type) {
      dispatch(setLocation("/cart-bundles"));
    } else {
      dispatch(fetchBundleFieldsDetails())
    }
  }, []);

  return (
    <Layout>
      <Section>
        <CartBundleForm
          onValidateInputs={onValidateInputs}
          registerField={onRegisterField}
          unRegisterField={onUnRegisterField}
          fieldsErrors={formErrors}
          getValue={getValue}
          canSubmit={FormValidationHandler()}
        />
      </Section>
    </Layout>
  )
}

export default CartBundleCreate